const Validation = {
	mandatory(v) {
		return !!v || "Obligatoire";
	}
};
export default Validation;
